"use client"

import { ReactNode, useRef } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

// Below 960 px the steps are one column as wide as the screen, so the chat launcher (fixed,
// bottom-right) can sit on top of the step's primary button, the pay button included (measured on the
// card step: overlap at 641-900 px, clear from 960 px, where the form is centred with free space at the
// right). Hidden there on /setup only (this layout wraps nothing else); Intercom stays available
// everywhere else, and on wider screens the launcher stays as the funnel's way to reach support.
const HIDE_LAUNCHER_WHERE_IT_COVERS_THE_FORM = `@media (max-width: 959px) {
  #intercom-facade-btn,
  .intercom-lightweight-app-launcher,
  .intercom-launcher-frame,
  .intercom-launcher,
  iframe[name="intercom-launcher-frame"] { display: none !important; }
}`

export function SetupClientProviders({ children }: { children: ReactNode }) {
    const queryClientRef = useRef<QueryClient | null>(null)
    if (!queryClientRef.current) {
        queryClientRef.current = new QueryClient()
    }
    return (
        <QueryClientProvider client={queryClientRef.current}>
            <style>{HIDE_LAUNCHER_WHERE_IT_COVERS_THE_FORM}</style>
            {children}
        </QueryClientProvider>
    )
}
